import { render, staticRenderFns } from "./ModulesList.vue?vue&type=template&id=a3f3e408&scoped=true"
import script from "./ModulesList.vue?vue&type=script&lang=js"
export * from "./ModulesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f3e408",
  null
  
)

export default component.exports